export default "__VITE_ASSET__jrtksTzE__"